import { Divider, Stack, type SvgIcon, Typography } from '@mui/material';
import { toast } from '@side/pantry';
import { CopyIconButton } from '@/components/CopyIconButton';

interface Props {
  content?: string | null;
  copyable?: boolean;
  copyButtonId?: string;
  Icon: typeof SvgIcon;
  onCopy?: () => unknown;
}
export const InformationItem = ({
  content,
  copyable,
  copyButtonId,
  Icon,
  onCopy,
}: Props) => {
  const handleCopy = (value: string) => {
    onCopy?.();
    void navigator.clipboard.writeText(value);
    toast('success', 'Copied');
  };

  return (
    <Stack
      direction="row"
      sx={{ alignItems: content ? 'flex-start' : 'center' }}
    >
      <Icon fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
      {content ? (
        <>
          <Typography variant="body2">{content}</Typography>
          {copyable ? (
            <CopyIconButton
              id={copyButtonId}
              fontSize="small"
              sx={{ ml: 0.75 }}
              onClick={() => handleCopy(content)}
            />
          ) : null}
        </>
      ) : (
        <Divider sx={{ width: (theme) => theme.spacing(3.5) }} />
      )}
    </Stack>
  );
};
